"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var AttributeFilterComponentsContext_1 = require("../../Context/AttributeFilterComponentsContext");
var AttributeFilterContext_1 = require("../../Context/AttributeFilterContext");
var useResolveAttributeFilterSubtitle_1 = require("../../hooks/useResolveAttributeFilterSubtitle");
var ALIGN_POINTS = [
    { align: "bl tl" },
    { align: "tr tl" },
    { align: "br tr", offset: { x: -11 } },
    { align: "tl bl", offset: { x: 0, y: 0 } },
    { align: "tr tl", offset: { x: 0, y: -50 } },
    { align: "tr tl", offset: { x: 0, y: -100 } },
    { align: "tr tl", offset: { x: 0, y: -200 } },
    { align: "tr tl", offset: { x: 0, y: -300 } },
    { align: "tr tl", offset: { x: 0, y: -400 } },
];
/**
 * @internal
 */
exports.AttributeFilterDropdown = function () {
    var _a = AttributeFilterComponentsContext_1.useAttributeFilterComponentsContext(), DropdownButtonComponent = _a.DropdownButtonComponent, DropdownBodyComponent = _a.DropdownBodyComponent;
    var _b = AttributeFilterContext_1.useAttributeFilterContext(), title = _b.title, isInitializing = _b.isInitializing, initError = _b.initError, isFiltering = _b.isFiltering, committedSelectionElements = _b.committedSelectionElements, onReset = _b.onReset, onApply = _b.onApply, fullscreenOnMobile = _b.fullscreenOnMobile, isCommittedSelectionInverted = _b.isCommittedSelectionInverted;
    var isMobile = sdk_ui_kit_1.useMediaQuery("mobileDevice");
    var subtitle = useResolveAttributeFilterSubtitle_1.useResolveAttributeFilterSubtitle(isCommittedSelectionInverted, committedSelectionElements);
    return (react_1.default.createElement(sdk_ui_kit_1.Dropdown, { className: "gd-attribute-filter__next", closeOnParentScroll: true, closeOnMouseDrag: true, closeOnOutsideClick: true, enableEventPropagation: true, alignPoints: ALIGN_POINTS, fullscreenOnMobile: fullscreenOnMobile, renderButton: function (_a) {
            var toggleDropdown = _a.toggleDropdown, isOpen = _a.isOpen;
            return (react_1.default.createElement("div", { className: classnames_1.default({ "gd-is-mobile": fullscreenOnMobile && isMobile && isOpen }) },
                react_1.default.createElement(DropdownButtonComponent, { title: title, subtitle: subtitle, isFiltering: isFiltering, isLoaded: !isInitializing && !initError, isLoading: isInitializing, isOpen: isOpen, selectedItemsCount: committedSelectionElements.length, onClick: toggleDropdown })));
        }, onOpenStateChanged: function (isOpen) {
            if (!isOpen) {
                onReset();
            }
        }, renderBody: function (_a) {
            var closeDropdown = _a.closeDropdown;
            return (react_1.default.createElement("div", { className: classnames_1.default({ "gd-is-mobile": fullscreenOnMobile && isMobile }), style: { height: fullscreenOnMobile && isMobile ? "100%" : "auto" } },
                react_1.default.createElement(DropdownBodyComponent, { onApplyButtonClick: function () {
                        onApply();
                        closeDropdown();
                    }, onCancelButtonClick: closeDropdown })));
        } }));
};
//# sourceMappingURL=AttributeFilterDropdown.js.map